import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { RootState } from '../../../../store';
import './../help-center.css';

interface IProblemOrderWidgetProps {
    onClose: () => void;
}

export const ProblemOrderWidget = ({ onClose }: IProblemOrderWidgetProps) => {
    return (
        <>
            <div className="box-collage-next">
                <button
                    className="boxes-btn"
                    onClick={() => {
                        onClose();
                    }}
                >
                    &lt;
                    <FormattedMessage id="Back" defaultMessage="Back" />
                </button>
                <h2>
                    <FormattedMessage
                        id="How_do_I_report_a_problem_with_my_order"
                        defaultMessage="Report Lost or Damaged Item(s)"
                    />
                </h2>
                <div className="row">
                    <div className="col-sm-6">
                        <h3>
                            <FormattedMessage
                                id="Step_by_step_guide"
                                defaultMessage="Step by Step Guide"
                            />
                        </h3>
                        <ol className="ordered-list">
                            <li>
                                <FormattedMessage
                                    id="On_the_estore_homepage"
                                    defaultMessage="Step 1. On the eStore home page, click ‘My Orders’ under ‘Quick Links’"
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="Search_for_the_order_you_would_update"
                                    defaultMessage="Step 2. Search for the order you would like to update and click on the order number or ‘See Details’"
                                />
                                <br />
                                <div className="italic">
                                    <FormattedMessage
                                        id="You_can_only_report_lost_damaged"
                                        defaultMessage="* You can only report a lost or damaged item(s) on orders that have been shipped or delivered"
                                    />
                                </div>
                            </li>
                            <li>
                                <FormattedMessage
                                    id="Under_manage_order_select"
                                    defaultMessage="Step 3. Under ‘Manage Order’ select ‘Report Lost or Damaged Item(s)’"
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="In_the_pop_up_fill_out"
                                    defaultMessage="Step 4. In the pop-up, fill out information and details about your issue"
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="Once_you_submit_your_report_you_will_receive"
                                    defaultMessage="Step 5. Once you submit your report, you will receive confirmation the order has been reported and a Customer Service Representative will reach out to you"
                                />
                            </li>
                        </ol>
                    </div>
                    <div className="col-sm-6">
                        <h3>
                            <FormattedMessage
                                id="Video_tutorial"
                                defaultMessage="Video Tutorial"
                            />
                        </h3>
                        <ol className="ordered-list">
                            <li>
                                <FormattedMessage
                                    id="How_to_report_damaged"
                                    defaultMessage="How to report lost or damaged items"
                                />
                                <iframe
                                    className="help-center-video"
                                    src="https://bcove.video/3BvFTkB"
                                    frameBorder="0"
                                    allow="autoplay; encrypted-media"
                                    allowFullScreen
                                    title="video"
                                />
                                <FormattedMessage
                                    id="Learn_how_to_report_issues"
                                    defaultMessage="Learn how to report issues with your order"
                                />
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    return {};
};

const mapDispatchToProps = {};

const problemOrderWidgetContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ProblemOrderWidget);

export default problemOrderWidgetContainer;
